export const gallerySectionWaterproofingSystems =
{
    "title": "Explore Our Work",
    "columns": 3,
    "rowHeight": 1200,
    "pageSize": 9,
    "images": [
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/1.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/2.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/3.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/4.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/5.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/6.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/7.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/8.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/9.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/10.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/11.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/12.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/13.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/14.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/15.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/16.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/17.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/18.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/19.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/20.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/21.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/22.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/23.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/24.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/25.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/26.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/27.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/28.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/29.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/30.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/31.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/32.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/33.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/34.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/35.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/36.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/37.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/38.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/39.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/40.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/41.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/42.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/43.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/44.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/45.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/46.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/47.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/48.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/49.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/50.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/51.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/52.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/53.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/54.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/55.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/56.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/57.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/58.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/59.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/60.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/61.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/62.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/63.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/64.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/65.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/66.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/67.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/68.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/69.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/70.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/71.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/72.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/00012WaterproofingSystems/73.jpg",
            "rowSpan": 2,
            "colSpan": 1
        }
    ]
}